import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";
import { requestAction } from "./onboardingRequestFields";

/**
 * How each action reads and looks.
 *
 * Reject is the only one that changes anything, and is the only one coloured
 * like a decision; the other two lead to the detail screen and are worded for
 * what is left to do there — answer it, or only read it back.
 */
const ACTIONS = {
  reject: {
    labelKey: "onboardingRequests.reject",
    busyKey: "onboardingRequests.rejecting",
    className: "border-rose-300 text-rose-700 hover:bg-rose-50",
  },
  review: {
    labelKey: "onboardingRequests.review",
    className:
      "border-primary/40 text-primary hover:bg-primary/5",
  },
  view: {
    labelKey: "formActions.view",
    className:
      "border-(--color-text-border) per-file-hint hover:bg-workspace/40",
  },
};

/**
 * The single thing a row offers, as one button whichever it is.
 *
 * The row and the card both sit inside something clickable, so the click is
 * stopped here rather than at each call site.
 */
export function RequestActionButton({ request, rejectingId, onOpen, onReject, className = "" }) {
  const { t } = useTranslation();

  const action = requestAction(request);
  const { labelKey, busyKey, className: tone } = ACTIONS[action];
  const rejecting = rejectingId === (request?.requestId ?? request?.id);

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        (action === "reject" ? onReject : onOpen)(request);
      }}
      disabled={action === "reject" && rejectingId != null}
      className={cn(
        "inline-flex h-8 items-center justify-center rounded-lg border px-3 text-[11px] font-bold transition disabled:cursor-not-allowed disabled:opacity-50",
        tone,
        className
      )}
    >
      {rejecting && busyKey ? t(busyKey) : t(labelKey)}
    </button>
  );
}

export default RequestActionButton;
